import React from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert2 from "react-sweetalert2";

import Api from "shared/resources/Api";
import Header from "components/Headers/Header.js";

export default class ImobiliariaEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      api: Api.baseURL,
      isEdicao: false,
      imobiliaria: {},
      formTitle: "CADASTRAR",
      requesting: false,
    };

    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    if (
      this.props.location != null &&
      this.props.location.state != null &&
      this.props.location.state.imobiliaria != null
    ) {
      const imobiliaria = this.props.location.state.imobiliaria;
      console.log(imobiliaria)
      this.setState({
        isEdicao: true,
        formTitle: "EDITAR",
        id: imobiliaria.oid_imobiliaria,
        ds_nome: imobiliaria.ds_nome || "",
        tp_ativo: imobiliaria.tp_ativo || "",
        ds_descricao: imobiliaria.ds_descricao || "",
      });
    }
  }
  validate = () => {
    if (this.state.ds_nome === "" || this.state.ds_nome === undefined) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o nome da imobiliária!",
          type: "warning",
        },
      });
      return false;
    }

    if (this.state.ds_descricao === "" || this.state.ds_descricao === undefined) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe a descrição da imobiliária!",
          type: "warning",
        },
      });
      return false;
    }
    if (this.state.tp_ativo === "" || this.state.tp_ativo === undefined) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "O status da imobiliária não pode ser vazio, selecione ativo ou inativo!",

          type: "warning",
        },
      });
      return false;
    }

    return true;
  };

  handleDownload = (event) => {
    event.preventDefault();
    // Método não aplicável para imobiliária
  };

  handleSave() {
    if (this.validate()) {
      this.setState({ requesting: true });
      this.callApi();
    }
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  };
  callApi = async () => {
    const imobiliariaData = {
      imobiliaria: {
        nome: this.state.ds_nome,
        descricao: this.state.ds_descricao,
        status: this.state.tp_ativo,
      }
    };

    const endpoint = this.state.isEdicao
      ? `/imobiliaria/${this.state.id}`
      : "/imobiliaria";

    const method = this.state.isEdicao ? "PUT" : "POST";

    try {
      const response = await fetch(Api.baseURL + endpoint, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("agToken"),
        },
        body: JSON.stringify(imobiliariaData),
      });

      const body = await response.json();

      if (response.ok) {
        this.setState({
          swal: {
            show: true,
            title: "Sucesso",
            text: this.state.isEdicao
              ? "Imobiliária editada com sucesso!"
              : "Imobiliária cadastrada com sucesso!",
            type: "success",
          },
          requesting: false,
          isSuccess: true,
        });
      } else {
        this.setState({
          swal: {
            show: true,
            title: "Erro",
            text: body.message || "Erro ao processar a imobiliária",
            type: "error",
          },
          requesting: false,
        });
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      this.setState({
        swal: {
          show: true,
          title: "Erro",
          text: "Erro ao conectar com o servidor",
          type: "error",
        },
        requesting: false,
      });
    }
  };

  onDrop(pictureFiles, pictureDataURLs) {
    // Método não aplicável para imobiliária
  }

  render() {
    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={(result) => {
            this.setState({
              swal: {
                show: false,
              },
            });
            if (this.state.isSuccess) {
              this.props.history.push("/admin/imobiliaria-list");
            }
          }}
        />
        <Header />
        {/* Page content */}
        <Container className="mb-7 mt-5" fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      {this.state.formTitle} IMOBILIÁRIA
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col md="8">
                          <FormGroup>
                            <label className="form-control-label" htmlFor="ds_nome">
                              Nome da Imobiliária *
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="ds_nome"
                              placeholder="Digite o nome da imobiliária"
                              type="text"
                              value={this.state.ds_nome || ""}
                              onChange={(e) =>
                                this.handleChange("ds_nome", e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <div>
                              <label
                                className="form-control-label"
                                htmlFor="tp_ativo"
                              >
                                Status *
                              </label>

                              <select
                               className="form-control"
                               id="tp_ativo"
                                value={this.state.tp_ativo}
                                onChange={(e) => {
                                   this.handleChange("tp_ativo", e.target.value)
                                }}
                              >
                                <option value="">Selecione...</option>
                                <option value="S">ativo</option>
                                <option value="N">inativo</option>
                              </select>
                            </div>                                                    
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md="12">
                          <FormGroup>
                            <label className="form-control-label" htmlFor="ds_descricao">
                              Descrição *
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="ds_descricao"
                              placeholder="Digite a descrição da imobiliária"
                              type="textarea"
                              rows="4"
                              value={this.state.ds_descricao || ""}
                              onChange={(e) =>
                                this.handleChange("ds_descricao", e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>

                    {localStorage.getItem("perm") === "coordenador" && (
                      <div className="text-center">
                        <Row>
                          <Col className="order-xl-1" xl="12">
                            <Button
                              className="mt-4 btn-zoo"
                              color="primary"
                              type="button"
                              onClick={this.handleSave}
                              disabled={this.state.requesting}
                            >
                              <b>
                                {this.state.isEdicao
                                  ? "Salvar Alterações"
                                  : "Cadastrar"}
                              </b>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.requesting && (
            <div className="text-center">
              <Spinner
                style={{ width: "3rem", height: "3rem" }}
                color="primary"
              />
            </div>
          )}
        </Container>
      </>
    );
  }
}
